import { AxiosError, AxiosResponse } from 'axios';

import { IQueryProps, QueryClient, UseQueryOptions, useQuery } from '@pricemoov-oss/moon';

const PRODUCT_CATALOG_METADATA_QUERY_ID = 'product-catalog-metadata-query-id';

export interface ProductCatalogMetadata {
    enabled: boolean;
    status: 'not-ready' | 'running' | 'failed' | 'success' | 'has-products';
}

const getProductCatalogMetadataQuery = (): Pick<IQueryProps, 'source' | 'id' | 'endPoint'> => {
    return {
        source: 'rest',
        id: PRODUCT_CATALOG_METADATA_QUERY_ID,
        endPoint: `api/platform/product_catalog/metadata/`,
    };
};

export function productCatalogsQueryDeserializer(
    response: AxiosResponse<ProductCatalogMetadata>
): ProductCatalogMetadata {
    return response?.data;
}

function useProductCatalogMetadataQuery(
    queryConfig?: UseQueryOptions<
        AxiosResponse<ProductCatalogMetadata>,
        AxiosError,
        ProductCatalogMetadata
    >
) {
    return useQuery<
        never,
        AxiosResponse<ProductCatalogMetadata>,
        ProductCatalogMetadata,
        AxiosError
    >({
        ...getProductCatalogMetadataQuery(),
        queryConfig: {
            select: productCatalogsQueryDeserializer,
            ...queryConfig,
        },
    });
}

/**
 * Update the product catalog Metadata.
 * @param store The cache store
 * @param newData The new metadata
 */
export function updateProductCatalogMetadata(store: QueryClient, newData: ProductCatalogMetadata) {
    const queryId = getProductCatalogMetadataQuery().id;
    store.setQueryData(
        queryId,
        (oldData: AxiosResponse<ProductCatalogMetadata>): AxiosResponse<ProductCatalogMetadata> => {
            return { ...oldData, data: newData };
        }
    );
}

export default useProductCatalogMetadataQuery;
